mutation UpdatePlatform($id: ID!, $input: UpdatePlatformInput!) {
  updatePlatform(id: $id, input: $input) {
    id
    updatedAt
  }
}

